import React from 'react';

const FullScreenButton = ({ isFullScreen, toggleFullScreen, showFullScreenButton }) => {
  if (!showFullScreenButton) {
    return null;
  }

  const handleLockingScroll = () => {
    if (isFullScreen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  const handleToggleFullScreen = () => {
    toggleFullScreen(!isFullScreen);
    handleLockingScroll();
  }
  
  return ( 
    <button 
      onClick={handleToggleFullScreen} 
      className={`${isFullScreen ? 'fullscreen-button' : 'minimized-screen-button'}`}
      style={isFullScreen ? { backgroundColor: 'transparent' } : {}}
    >
      <i className={`${isFullScreen ? 'fa-light fa-x' : 'fas fa-expand-arrows-alt'}`}></i>
    </button>
  );
};

export default FullScreenButton; 